 
import { getCookie } from "@insite/client-framework/Common/Cookies";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
// import { MainNavigationStyles, MappedLink } from "@insite/content-library/Widgets/Header/MainNavigation"; // Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
// import ChevronDown from "@insite/mobius/Icons/ChevronDown"; // Custom Code
import Link, { StyledIcon } from "@insite/mobius/Link";
import Menu from "@insite/mobius/Menu";
import Popover from "@insite/mobius/Popover";
import * as React from "react";
import { ThemeProps, withTheme } from "styled-components";
import { css } from "styled-components";
/* Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
// import { MainNavigationStyles, MappedLink } from "@store/Overrides/Widgets/Header/MainNavigation"; // Store Custom Code
import ChevronDown from "@store/Library/Components/Icons/ChevronDown";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    currentLocation: getLocation(state),
});

const getFilteredChildren = (child: MappedLink, displayChangeCustomerLink: boolean) => {
    return (
        child.children?.filter(children => {
            if (children.excludeFromNavigation) {
                return false;
            }
            if (children.type === "ChangeCustomerPage" && !displayChangeCustomerLink) {
                return false;
            }
            if (children.type === "VmiUsersPage") {
                const currentMode = getCookie(NavigationModeCookieName);
                if (!currentMode || currentMode === "Storefront") {
                    return false;
                }
            }
            return true;
        }) || []
    );
};

const toSafeId = (value: string, fallback: string) => {
    const normalized = (value || "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    return normalized || fallback;
};
/* Custom Code - End */

/* Store Custom Code - Start */
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Button from "@store/MobiusOverrides/Button/Button";
import { MainNavigationStyles, MappedLink } from "@store/Overrides/Widgets/Header/MainNavigation";
/* Store Custom Code - End */

interface OwnProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement | null>;
    isOpen: boolean;
    displayChangeCustomerLink: boolean;
    // Store Custom Code
    onTabChange?: (event: React.MouseEvent | React.KeyboardEvent) => void;
    suppressLandmarks?: boolean;
}

const linkStyles = css`
    font-size: 24px !important;
    cursor: pointer;
    font-family: inherit;
    min-height: 45px;
    backface-visibility: hidden;
    word-break: keep-all;
    padding: 0.5rem 1rem;
    border: none;
    background: #00305e;
    color: rgb(255, 255, 255);
    font-size: 16px;
    min-width: 120px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 100ms ease-out, background-color 100ms ease-out, border-color 100ms ease-out;
    font-weight: 700;
    line-height: 1.25;

    /* Hover styles using :hover pseudo-class */
    &:hover {
        text-decoration: none;
        border: none;
        color: white;
        background: #3da7d3;
    }
`;

type Props = ThemeProps<BaseTheme> & OwnProps & ReturnType<typeof mapStateToProps> /* Custom Code */;

/* Custom Code - Start */
type State = {
    currentTab?: string;
    isCurrentTabOpen?: boolean;
};
/* Custom Code - End */

class MainNavigationItem extends React.Component<Props, State /* Custom Code */> {
    /* Custom Code - Start */
    firstTabKey: string | undefined = undefined;

    constructor(props: Props) {
        super(props);

        this.state = {
            currentTab: undefined,
            isCurrentTabOpen: false,
        };
    }
    /* Custom Code - End */

    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();

    componentDidUpdate(prevProps: Readonly<Props>) {
        /* Custom Code - Start */
        if (!this.firstTabKey) {
            this.initNav();
        }
        /* Custom Code - End */
        if (this.props.isOpen && !prevProps.isOpen) {
            this.openPopover();
        } else if (!this.props.isOpen && prevProps.isOpen) {
            this.closePopover();
        }
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    /* Custom Code - Start */
    initNav = () => {
        const firstChild = this.props.link?.children?.filter(child => !child.excludeFromNavigation)[0];
        const tabKey = firstChild?.title;

        if (tabKey) {
            this.firstTabKey = tabKey;
            this.setState({ currentTab: tabKey, isCurrentTabOpen: true });
        }
    };

    changeTab = (tabKey: string, event: React.MouseEvent | React.KeyboardEvent) => {
        // Store Custom Code
        if (tabKey === this.state.currentTab) {
            this.setState({ currentTab: tabKey, isCurrentTabOpen: !this.state.isCurrentTabOpen });
        } else {
            this.setState({ currentTab: tabKey, isCurrentTabOpen: true });
            /* Store Custom Code - Start */
             
            this.props.onTabChange && this.props.onTabChange(event);
            /* Store Custom Code - End */
        }
    };
    /* Custom Code - End */
    /* Store Custom Code - Start */
    clickLink = () => {
        this.closePopover();
        return true;
    };

    onOpenMegaMenu = () => {
        this.initNav();
    };
    /* Store Custom Code - End */

    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading = hasChildren && link.childrenType === "CascadingMenu";
        /* Custom Code - Start */
        const isMega = hasChildren && link.childrenType === "MegaMenu" && !link.isMegaMenuWithTabs;
        const isMegaWithTabs = hasChildren && link.childrenType === "MegaMenu" && link.isMegaMenuWithTabs;
        const maxChild = link.maxChild ?? 99;
        const maxChildren = link.maxChildren ?? 3;
        const maxGrandChildren = link.maxGrandChildren ?? 3;
        const { currentTab, isCurrentTabOpen } = this.state;
        const linkIdBase = toSafeId(link.title || "", `main-nav-${index}`);
        const { suppressLandmarks } = this.props;
        /* Custom Code - End */

        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={link.url}
                target={link.openInNewWindow ? "_blank" : "_self"} // Custom Code
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );
        if (isMega || link.url === "" || isMegaWithTabs /* Custom Code */) {
            menuLink = (
                <Link
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    /* Removed - color */
                    {...styles.menuItem}
                >
                    {link.title}
                    {(isCascading || isMega || isMegaWithTabs) /* Custom Code */ && downIcon}
                </Link>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${linkIdBase}-${index}`}
                    menuItems={link.children}
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    {...(suppressLandmarks ? ({ as: "div" } as any) : null)}
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }

        /* Store Custom Code - Start */
        const chunks = (arr: any[], n: number) => {
            const size = Math.ceil(arr.length / n);
            return Array.from({ length: n }, (v, i) => arr.slice(i * size, i * size + size));
        };

        const subLinks = (links: MappedLink[]) => {
            const LinksOutput = links
                .filter(link => {
                    if (link.excludeFromNavigation) {
                        return false;
                    }
                    if (link.type === "ChangeCustomerPage" && !this.props.displayChangeCustomerLink) {
                        return false;
                    }
                    if (link.type === "VmiUsersPage") {
                        const currentMode = getCookie(NavigationModeCookieName);
                        if (!currentMode || currentMode === "Storefront") {
                            return false;
                        }
                    }
                    return true;
                })
                .slice(0, maxGrandChildren)
                .map((link, index) => (
                    <StyledWrapper as="li" key={index}>
                        <Link
                            className="mega-menu-link"
                            {...styles.megaMenuSubLink}
                            onClick={this.closePopover}
                            href={link.url}
                            data-test-selector={link.title}
                        >
                            <StyledWrapper as="span">{link.title}</StyledWrapper>
                        </Link>
                    </StyledWrapper>
                ));
            return (
                <StyledWrapper as="ul" {...styles.megaMenuSubLinkList}>
                    {LinksOutput}
                </StyledWrapper>
            );
        };

        /* Store Custom Code - End */

        if (isMega) {
            menuItem = (
                <Popover
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    wrapperProps={suppressLandmarks ? ({ as: "div" } as any) : undefined}
                    contentBodyProps={{
                        ...styles.megaMenu?.contentBodyProps,
                        /* Removed - _width */
                        as: "div",
                    }}
                    controlsId={`mega-menu-${linkIdBase}-${index}`}
                    ref={this.popover}
                    positionFunction={(element: React.RefObject<HTMLUListElement | null>) => {
                        return { position: "fixed" }; // Custom Code
                    }}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                    onOpen={this.onOpenMegaMenu} // Store Custom Code
                >
                    <StyledWrapper {...styles.megaMenuContentWrapper} /* Custom Code */>
                        <GridContainer
                            className="mega-menu-grid-container"
                            data-test-selector={`mainNavigationItem_${index}`}
                            {...styles.megaMenuGridContainer}
                            offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                        >
                            {link
                                .children!.filter(child => !child.excludeFromNavigation)
                                .slice(0, maxChild) // Custom Code
                                .map((child, index) => {
                                    const tabKey = child.title; // Store Custom Code
                                    return (
                                        <GridItem
                                            className="mega-menu-grid-item"
                                            // Store Removed - Width
                                            key={`${child.title}-${index}`}
                                            {...styles.megaMenuGridItem}
                                            as="div"
                                        >
                                            {/* Store Custom Code - Start */}
                                            <Link
                                                className="mega-menu-heading-link"
                                                {...styles.megaMenuHeading}
                                                onClick={event => this.changeTab(tabKey, event)}
                                                aria-haspopup="true"
                                                aria-expanded={tabKey === currentTab && isCurrentTabOpen}
                                                data-is-open={tabKey === currentTab}
                                            >
                                                {child.title}
                                            </Link>

                                            {tabKey === currentTab && child.children && child.children.length > 0 && (
                                                <StyledWrapper
                                                    style={{ flexDirection: "column" }}
                                                    className="targetdiv1"
                                                    {...styles.megaMenuListLinks}
                                                >
                                                    <StyledWrapper
                                                        as="li"
                                                        {...styles.megaMenuChildren}
                                                        style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            paddingLeft: "40px",
                                                            paddingRight: "40px",
                                                            paddingBottom: "14px",
                                                            alignItems: "center",
                                                            flexDirection: "row",
                                                            justifyContent: "space-between",
                                                            // borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                                                        }}
                                                    >
                                                        <StyledWrapper
                                                            as="h2"
                                                            style={{
                                                                fontWeight: 900,
                                                                fontSize: "20px",
                                                                margin: 0,
                                                                padding: 0,
                                                                textTransform: "uppercase",
                                                            }}
                                                            {...styles.megaMenuListItemLink}
                                                        >
                                                            {child.title || ""}
                                                        </StyledWrapper>
                                                        {
                                                            // Print only in the first column at the top. // View All Products SEO Link
                                                            <StyledWrapper
                                                                as="h2"
                                                                style={{
                                                                    margin: 0,
                                                                    padding: 0,
                                                                }}
                                                                {...styles.megaMenuListItemLink}
                                                            >
                                                                <Button
                                                                    css={linkStyles}
                                                                    style={{
                                                                        textDecoration: "underline",
                                                                        textTransform: "uppercase",
                                                                    }}
                                                                    onClick={this.closePopover}
                                                                    href={child.url}
                                                                >
                                                                    {translate("See all {0}", child.title || "")}
                                                                </Button>
                                                            </StyledWrapper>
                                                        }
                                                    </StyledWrapper>
                                                    <div
                                                        style={{
                                                            marginLeft: "40px",
                                                            marginRight: "40px",
                                                            borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                                                        }}
                                                    ></div>
                                                    <StyledWrapper
                                                        as="ul"
                                                        key={index}
                                                        {...styles.megaMenuChildrenWrapper}
                                                    >
                                                        {chunks(child.children, maxGrandChildren).map(
                                                            (chunk, index) => {
                                                                return (
                                                                    <StyledWrapper
                                                                        as="li"
                                                                        key={index}
                                                                        {...styles.megaMenuChildren}
                                                                    >
                                                                        {chunk
                                                                            .filter(grandChild => {
                                                                                if (grandChild.excludeFromNavigation) {
                                                                                    return false;
                                                                                }
                                                                                if (
                                                                                    grandChild.type ===
                                                                                        "ChangeCustomerPage" &&
                                                                                    !this.props
                                                                                        .displayChangeCustomerLink
                                                                                ) {
                                                                                    return false;
                                                                                }
                                                                                if (
                                                                                    grandChild.type === "VmiUsersPage"
                                                                                ) {
                                                                                    const currentMode =
                                                                                        getCookie(
                                                                                            NavigationModeCookieName,
                                                                                        );
                                                                                    if (
                                                                                        !currentMode ||
                                                                                        currentMode === "Storefront"
                                                                                    ) {
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                return true;
                                                                            })
                                                                            .slice(0, maxChildren + 1)
                                                                            .map((grandChild, index) => (
                                                                                <StyledWrapper
                                                                                    key={index}
                                                                                    {...styles.megaMenuListItemLink}
                                                                                >
                                                                                    <Link
                                                                                        className="mega-menu-link"
                                                                                        onClick={this.closePopover}
                                                                                        href={grandChild.url}
                                                                                        {...styles.megaMenuLink}
                                                                                        data-test-selector={
                                                                                            grandChild.title
                                                                                        }
                                                                                        tabIndex={
                                                                                            isCurrentTabOpen ? 0 : -1
                                                                                        } // Store Custom Code
                                                                                    >
                                                                                        {grandChild.title}
                                                                                    </Link>
                                                                                    {grandChild.children &&
                                                                                        grandChild.children.length >
                                                                                            0 &&
                                                                                        subLinks(grandChild.children)}
                                                                                    {grandChild.children &&
                                                                                        grandChild.children.length >
                                                                                            maxGrandChildren && (
                                                                                            <Link
                                                                                                className="mega-menu-link"
                                                                                                {...styles.megaMenuMoreSubLink}
                                                                                                onClick={
                                                                                                    this.closePopover
                                                                                                }
                                                                                                href={grandChild.url}
                                                                                                data-test-selector={
                                                                                                    grandChild.title
                                                                                                }
                                                                                                tabIndex={
                                                                                                    isCurrentTabOpen
                                                                                                        ? 0
                                                                                                        : -1
                                                                                                } // Store Custom Code
                                                                                            >
                                                                                                <StyledWrapper as="span">
                                                                                                    {translate(
                                                                                                        "See all {0}",
                                                                                                        grandChild.title ||
                                                                                                            "",
                                                                                                    )}
                                                                                                </StyledWrapper>
                                                                                            </Link>
                                                                                        )}
                                                                                </StyledWrapper>
                                                                            ))}
                                                                    </StyledWrapper>
                                                                );
                                                            },
                                                        )}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            )}
                                        </GridItem>
                                    );
                                })}
                            {/* Custom Code - Start */}
                            {this.props.link.url && (
                                <GridItem key={'view-all-uniq0'} width={12} as="li" {...styles.megaMenuViewAllGridItem}>
                                    <Link
                                        {...styles.megaMenuViewAllLink}
                                        onClick={this.closePopover}
                                        href={this.props.link.url}
                                    >
                                        {translate("View All")} {this.props.link.title}
                                    </Link>
                                </GridItem>
                            )}
                            {/* Custom Code - End */}
                        </GridContainer>
                    </StyledWrapper>
                </Popover>
            );
        }

        /* Custom Code - Start */
        if (isMegaWithTabs) {
            const child = link.children!.filter(child => !child.excludeFromNavigation);
            menuItem = (
                <Popover
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    wrapperProps={suppressLandmarks ? ({ as: "div" } as any) : undefined}
                    contentBodyProps={{
                        ...styles.megaMenuWithTabs?.contentBodyProps,
                        as: "div",
                    }}
                    controlsId={`mega-menu-tabs-${linkIdBase}-${index}`}
                    ref={this.popover}
                    positionFunction={() => ({ position: "fixed" })}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                    onOpen={this.initNav}
                >
                    <StyledWrapper {...styles.megaMenuWithTabsContentWrapper}>
                        <StyledWrapper {...styles.megaMenuWithTabsWrapper} as="ul">
                            {child.slice(0, maxChild).map((child, index) => {
                                const tabKey = child.title;
                                const id = `mega-tab-panel-${index}-${toSafeId(child.title || "", "item")}`;
                                const hasChildren = Boolean(child.children?.some(x => !x.excludeFromNavigation));
                                return (
                                    <StyledWrapper as="li" key={child.title} {...styles.megaMenuWithTabsMainChild}>
                                        <Link
                                            {...(tabKey === currentTab || hasChildren
                                                ? styles.megaMenuWithTabsMainChildWithSubmenuLink
                                                : styles.megaMenuWithTabsMainChildLink)}
                                            href={!hasChildren ? child.url : undefined}
                                            onClick={
                                                tabKey === currentTab || hasChildren
                                                    ? event => this.changeTab(tabKey, event) /* Store Custom Code */
                                                    : this.closePopover
                                            }
                                            aria-haspopup={tabKey === currentTab || hasChildren}
                                            aria-controls={id}
                                            aria-expanded={tabKey === currentTab}
                                            aria-current={
                                                this.props.currentLocation.pathname === child.url ? "page" : undefined
                                            }
                                        >
                                            {child.title}
                                        </Link>

                                        {tabKey === currentTab && (
                                            <GridContainer
                                                id={id}
                                                className="mega-menu-grid-container"
                                                data-test-selector={`mainNavigationItem_${index}`}
                                                {...styles.megaMenuWithTabsGridContainer}
                                                offsetProps={{
                                                    ...styles.megaMenuWithTabsGridContainer?.offsetProps,
                                                    as: "ul",
                                                }}
                                            >
                                                {getFilteredChildren(child, this.props.displayChangeCustomerLink)
                                                    .slice(0, maxChildren)
                                                    .map(children => (
                                                        <GridItem
                                                            className="mega-menu-grid-item"
                                                            width={(12 / link.numberOfColumns!) as GridWidths}
                                                             
                                                            key={index}
                                                            {...styles.megaMenuGridItem}
                                                        >
                                                            <Link
                                                                className="mega-menu-heading-link"
                                                                {...styles.megaMenuHeading}
                                                                href={children.url}
                                                                onClick={this.closePopover}
                                                                tabIndex={isCurrentTabOpen ? 0 : -1}
                                                                aria-current={
                                                                    this.props.currentLocation.pathname === children.url
                                                                        ? "page"
                                                                        : undefined
                                                                }
                                                            >
                                                                {children.title}
                                                            </Link>
                                                            {children.children && children.children.length > 0 && (
                                                                <StyledWrapper
                                                                    as="ul"
                                                                    {...styles.megaMenuChildren}
                                                                    data-test-selector={`linksFor_${child.title}`}
                                                                >
                                                                    {getFilteredChildren(
                                                                        children,
                                                                        this.props.displayChangeCustomerLink,
                                                                    )
                                                                        .slice(0, maxGrandChildren + 1)
                                                                        .map((grandChildren, index) => {
                                                                            return index >= maxGrandChildren ? (
                                                                                <li key={grandChildren.title}>
                                                                                    <Link
                                                                                        className="mega-menu-more-link"
                                                                                        {...styles.megaMenuSeeMoreLink}
                                                                                        onClick={this.closePopover}
                                                                                        href={children.url}
                                                                                        tabIndex={
                                                                                            isCurrentTabOpen ? 0 : -1
                                                                                        }
                                                                                        aria-current={
                                                                                            this.props.currentLocation
                                                                                                .pathname ===
                                                                                            children.url
                                                                                                ? "page"
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        {translate(
                                                                                            "See all ({0})",
                                                                                            children.children?.length.toString() ||
                                                                                                "",
                                                                                        )}
                                                                                    </Link>
                                                                                </li>
                                                                            ) : (
                                                                                <li key={grandChildren.title}>
                                                                                    <Link
                                                                                        className="mega-menu-link"
                                                                                        {...styles.megaMenuLink}
                                                                                        onClick={this.closePopover}
                                                                                        href={grandChildren.url}
                                                                                        data-test-selector={
                                                                                            grandChildren.title
                                                                                        }
                                                                                        tabIndex={
                                                                                            isCurrentTabOpen ? 0 : -1
                                                                                        }
                                                                                        aria-current={
                                                                                            this.props.currentLocation
                                                                                                .pathname ===
                                                                                            grandChildren.url
                                                                                                ? "page"
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        {grandChildren.title}
                                                                                    </Link>
                                                                                </li>
                                                                            );
                                                                        })}
                                                                </StyledWrapper>
                                                            )}
                                                        </GridItem>
                                                    ))}
                                                <GridItem width={12} {...styles.megaMenuGridItem}>
                                                    <Link
                                                        {...styles.megaMenuViewAllLink}
                                                        onClick={this.closePopover}
                                                        href={child.url}
                                                        tabIndex={isCurrentTabOpen ? 0 : -1}
                                                        aria-current={
                                                            this.props.currentLocation.pathname === child.url
                                                                ? "page"
                                                                : undefined
                                                        }
                                                    >
                                                        {translate("See all {0}", child.title || "")}
                                                    </Link>
                                                </GridItem>
                                            </GridContainer>
                                        )}
                                    </StyledWrapper>
                                );
                            })}
                            {this.props.link.url && maxChild < child.length && (
                                <StyledWrapper as="li" {...styles.megaMenuWithTabsViewAllWrapper}>
                                    <Link
                                        {...styles.megaMenuWithTabsViewAllLink}
                                        onClick={this.closePopover}
                                        href={this.props.link.url}
                                    >
                                        {translate("View All")} {this.props.link.title}
                                    </Link>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                </Popover>
            );
        }
        /* Custom Code - End */

        return menuItem;
    }
}

export default connect(mapStateToProps)(withTheme(MainNavigationItem)) /* Custom Code */;
